import { Button, Grid, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const BecomeAdvertizer = () => {
	const { t } = useTranslation();
	const subtext = t('advertiser');
	const navigate = useNavigate();

	const handleClick = () => {
		navigate('/my-social-media/new');
	};

	return (
		<Grid container className="flex min-h-72 rounded-lg bg-background-paper py-3 pl-4 pr-8">
			<Grid item className="flex h-full flex-1 flex-col justify-center gap-y-8 self-center">
				<Typography className="text-center text-2xl font-medium text-text-primary">
					<Trans i18nKey="become-advertizer-message" values={{ subtext }} components={[<span className="text-primary-main" />]} />
				</Typography>
				<Button sx={{ boxShadow: 3 }} variant="contained" className="h-14 text-base text-primary-contrastText" onClick={handleClick}>
					{t('become-advertizer-now')}
				</Button>
			</Grid>
			<Grid item>
				<img src="/images/become-advertizer.svg" alt="ads img" className="h-full" />
			</Grid>
		</Grid>
	);
};

export default BecomeAdvertizer;
